import React from "react";
import styled from "styled-components";
import { tokens } from "../../public/tokens";
import { IMAGE_URL } from "../../utils/Constants";

const StyledAvatar = styled.span(({ $hasImage = false, $size = 26 }) => ({
    width: `${$size}px`,
    height: `${$size}px`,
    borderRadius: "50%",
    background: $hasImage ? "transparent" : tokens.colors.neutral.grey["300"],
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    overflow: "hidden",

    img: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
    },
}));

const StyledInitials = styled.span({
    color: tokens.colors.neutral.black,
    fontSize: tokens.typography.fontSize["sm-10px"],
    fontFamily: tokens.typography.fontFamilies["albert-sans"],
    fontWeight: tokens.typography.fontWeights.bold,
});

/**
 * Up to 2 uppercase initials from a full name, e.g. "First Last" -> "FL".
 * @param {string} [name]
 */
export function getInitials(name) {
    return (
        (name || "")
            .split(" ")
            .filter(Boolean)
            .map((part) => part[0])
            .join("")
            .slice(0, 2)
            .toUpperCase() || "??"
    );
}

/**
 * Resolves a stored `picture_me` server path to its public URL, as the rest of the app does.
 * @param {string} image
 */
function getImageSrc(image) {
    return `${IMAGE_URL}/${image.replace("/home/myaie/public_html/", "")}`;
}

/**
 * A person's avatar image, or their initials on a neutral circle when no image is set.
 * @param {string} [props.name] Full name, used to compute initials when there's no image.
 * @param {string} [props.image] Stored `picture_me` path of the avatar image.
 * @param {number} [props.size=26] Diameter in px.
 */
function Avatar({ name, image, size = 26, className }) {
    return (
        <StyledAvatar $hasImage={Boolean(image)} $size={size} className={className}>
            {image ? (
                <img src={getImageSrc(image)} alt="" />
            ) : (
                <StyledInitials>{getInitials(name)}</StyledInitials>
            )}
        </StyledAvatar>
    );
}

export default Avatar;
